/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import { withTranslation } from 'react-i18next'

import BlockBuilder from './BlockBuilder'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'
import note_icon from '../../../assets/images/common/icons/note.png'
import './SessionBuilder.scss'

class SessionBuilder extends React.Component {
  state = {
    sessionNotesModal: false,
  }

  componentDidMount() {
    this.comp.addEventListener('scroll', this._checkSticky)
  }

  componentWillUnmount() {
    this.comp.removeEventListener('scroll', this._checkSticky)
  }

  render() {
    const {
      session,
      addBlock,
      handleSessionInput,
      grabTask,
      handleBlockInput,
      handleDeleteBlock,
      handleMoveBlock,
      sessionLoader,
      t,
    } = this.props
    const { sessionNotesModal } = this.state
    if (sessionLoader) {
      return (
        <div id='sessionBuilderLoader'>
          <Loader message={t('lessonPlans.sessionBuilder.grabbingSession')} />
        </div>
      )
    }
    return (
      <div id='SessionBuilder' ref={el => (this.comp = el)}>
        <div className='title-bar'>
          <input
            type='text'
            value={session.name}
            onChange={handleSessionInput}
            className='session-title'
            name='name'
            placeholder={t('lessonPlans.sessionBuilder.addNamePlaceholder')}
          />
          <div
            className={`note-icon ${session.notes ? 'note-present' : ''}`}
            style={{ backgroundImage: `url(${note_icon})` }}
            onClick={() => this.setState({ sessionNotesModal: true })}
          />
        </div>
        <div className='set-duration-container'>
          <p className='set-duration-input-label'>
            {t('lessonPlans.sessionBuilder.duration')}
          </p>
          <input
            type='number'
            name='duration'
            value={session.duration}
            onChange={handleSessionInput}
            placeholder={t('lessonPlans.sessionBuilder.minutesPlaceholder')}
            onWheel={e => e.target.blur()}
            onBlur={
              session.duration === ''
                ? () =>
                  handleSessionInput({
                    target: { name: 'duration', value: 0 },
                  })
                : () => false
            }
          />
        </div>
        <div ref={el => (this.sticky = el)}>
          <div className='duration-info-container'>
            <p className='duration-ratio'>{this._grabDurationRatio()}</p>
            <p
              className={`duration-remaining ${
                this._checkOverTime() ? 'over-time' : ''
              }`}
            >
              {this._grabTimeRemaining()}
            </p>
          </div>
          <div className='duration-bar-container'>
            <div className='duration-bar-outline' />
            <div className='duration-bar-fill' style={this._calculateStyle()} />
          </div>{' '}
        </div>
        <div ref={el => (this.blockContainer = el)}>
          {session.blocks.length > 0 ? (
            session.blocks.map((block, index) => (
              <BlockBuilder
                block={block}
                key={index}
                index={index}
                grabTask={grabTask}
                handleBlockInput={handleBlockInput}
                deleteBlock={handleDeleteBlock}
                moveBlock={handleMoveBlock}
              />
            ))
          ) : (
            <div className='zero-block-placeholder'>
              <p className='zero-block-placeholder-text'>
                {t('lessonPlans.sessionBuilder.zeroBlocksPlaceholder')}
              </p>
            </div>
          )}
        </div>
        <div className='add-block-container' onClick={addBlock}>
          <p className='add-block-button'>
            {t('lessonPlans.sessionBuilder.addBlock')}
          </p>
        </div>
        {sessionNotesModal && (
          <div className='grey-out1' onClick={this._closeSessionNotesModal} />
        )}
        {sessionNotesModal && (
          <div className='session-notes-modal'>
            <div className='session-notes-icon-container'>
              <i
                className='fa fa-times'
                aria-hidden='true'
                aria-label={t('common.close')}
                onClick={this._closeSessionNotesModal}
              />
            </div>
            <p className='session-notes-title'>
              {t('lessonPlans.sessionBuilder.sessionNotes')}
            </p>
            <p className='session-notes-subtitle'>{session.name}</p>
            <p>{t('common.field.notes')}</p>
            <textarea
              value={session.notes}
              name='notes'
              onChange={handleSessionInput}
              className='session-notes-textarea'
            ></textarea>
            <div className='session-notes-ok-button-container'>
              <button
                className='session-notes-ok-button'
                onClick={this._closeSessionNotesModal}
              >
                {t('lessonPlans.sessionBuilder.ok')}
              </button>
            </div>
          </div>
        )}
      </div>
    )
  }

  _checkSticky = _e => {
    if (this.comp.scrollTop >= 149) {
      this.sticky.classList.add('sticky')
      this.blockContainer.classList.add('pad')
    } else {
      this.sticky.classList.remove('sticky')
      this.blockContainer.classList.remove('pad')
    }
  }

  _grabDurationRatio = () => {
    const sessionDuration = this.props.session.duration
    let blocksDuration = 0
    this.props.session.blocks.map(block => {
      const duration = parseInt(block.duration, 10)
      if (duration > 0) {
        blocksDuration += duration
      }
    })
    const formattedSessionDuration = this._splitTime(sessionDuration)
    const formattedBlocksDuration = this._splitTime(blocksDuration)
    return this.props.t('lessonPlans.sessionBuilder.durationRatio', {
      blocksHours: formattedBlocksDuration.hours,
      blocksMins: formattedBlocksDuration.mins,
      sessionHours: formattedSessionDuration.hours,
      sessionMins: formattedSessionDuration.mins,
    })
  }

  _checkOverTime = () => {
    const sessionDuration = this.props.session.duration
    let blocksDuration = 0
    this.props.session.blocks.map(block => {
      const duration = parseInt(block.duration, 10)
      if (duration > 0) {
        blocksDuration += duration
      }
    })
    return blocksDuration > sessionDuration
  }

  _grabTimeRemaining = () => {
    const sessionDuration = this.props.session.duration
    let blocksDuration = 0
    this.props.session.blocks.map(block => {
      const duration = parseInt(block.duration, 10)
      if (duration > 0) {
        blocksDuration += duration
      }
    })
    let timeLeft

    if (sessionDuration > blocksDuration) {
      timeLeft = this._splitTime(sessionDuration - blocksDuration)
    } else if (sessionDuration === blocksDuration) {
      timeLeft = this._splitTime(0)
    } else {
      timeLeft = this._splitTime(blocksDuration - sessionDuration)
      return this.props.t('lessonPlans.sessionBuilder.timeOver', {
        hours: timeLeft.hours,
        mins: timeLeft.mins,
      })
    }

    return this.props.t('lessonPlans.sessionBuilder.timeLeft', {
      hours: timeLeft.hours,
      mins: timeLeft.mins,
    })
  }

  _calculateStyle = () => {
    const sessionDuration = this.props.session.duration
    let blocksDuration = 0
    this.props.session.blocks.map(block => {
      const duration = parseInt(block.duration, 10)
      if (duration > 0) {
        blocksDuration += duration
      }
    })
    const percentage =
      sessionDuration > 0 && blocksDuration > 0
        ? (blocksDuration / sessionDuration) * 100
        : 0

    const displayPercentage = percentage > 100 ? '100%' : `${percentage}%`
    return displayPercentage === '100%'
      ? {
        width: '100%',
        borderTopRightRadius: '500px',
        borderBottomRightRadius: '500px',
      }
      : { width: `${displayPercentage}` }
  }

  _closeSessionNotesModal = () => {
    this.setState({ sessionNotesModal: false })
  }

  _splitTime = minutes => {
    let hours = parseInt(minutes / 60, 10).toString()
    let mins = parseInt(minutes % 60, 10).toString()

    if (hours.length < 2) {
      hours = '0' + hours
    }
    if (mins.length < 2) {
      mins = '0' + mins
    }
    return { hours, mins }
  }
}

export default withTranslation()(SessionBuilder)
